// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-close-button {
    font-size: 20px;
    background: transparent;
    border: none;
    cursor: pointer;
  }
  
  .modal-content {
    margin-top: 20px;
  }
  
  .modal-table-container {
    max-height: 400px; /* Set the maximum height for the table container */
    overflow-y: auto; /* Add vertical scroll for the table rows */
  }
  
  .modal-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .modal-table th,
  .modal-table td {
    padding: 8px;
    border: 1px solid #ccc;
  }
  
  .modal-table th {
    background-color: #f2f2f2;
    text-align: left;
  }
  
  .modal-table tr:hover {
    background-color: #f9f9f9;
  }
  
  /* Search input styles */
  .search-input {
    margin-top: 10px;
    padding: 8px;
    width: 100%;
  }
  
  /* Send button styles */
  .modal-send-button {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .modal-send-button:hover {
    background-color: #0056b3;
  }
  
  .btn-effect{
   font-size: 10px !important;
  }
  
  .scale-effect {
    transform: scale(1.001);
  }
  
  /* "Select All" button styles */
  .select-all-button {
    margin-bottom: 10px;
    padding: 8px 12px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .select-all-button:hover {
    background-color: #0056b3;
  }
  
  /* Add any other custom styles as needed for your specific design */
  
  /* SendInvoices.css */

/* ... (previous styles) */

/* Date Range Container */
.date-range-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  /* Selected Date Range */
  .selected-date-range {
    font-weight: bold;
  }
  
  /* Selected Billing Category */
  .selected-billing-category {
    font-weight: bold;
  }
  
  /* Default Invoice Date */
  .invoice-date {
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;
  }
  
  /* Calendar Styles */
  .calendar-container {
    position: absolute;
    top: calc(100% + 5px); /* Position the calendar below the Default Invoice Date element */
    left: 0;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 10px;
    display: none; /* Hide the calendar initially */
  }
  
  .calendar-container.active {
    display: block; /* Show the calendar when active */
  }
  
  /* Add any other custom styles as needed for your specific design */
  .dollor>span{
    margin: 0px 3px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Hospital/SendInvoices.css"],"names":[],"mappings":";;EAEE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB,EAAE,mDAAmD;IACtE,gBAAgB,EAAE,2CAA2C;EAC/D;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,wBAAwB;EACxB;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;GACC,0BAA0B;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,+BAA+B;EAC/B;IACE,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,mEAAmE;;EAEnE,qBAAqB;;AAEvB,0BAA0B;;AAE1B,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,iBAAiB;IACjB,eAAe;IACf,0BAA0B;EAC5B;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,qBAAqB,EAAE,iEAAiE;IACxF,OAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa,EAAE,gCAAgC;EACjD;;EAEA;IACE,cAAc,EAAE,kCAAkC;EACpD;;EAEA,mEAAmE;EACnE;IACE,eAAe;EACjB","sourcesContent":["\n  \n  .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .modal-close-button {\n    font-size: 20px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .modal-content {\n    margin-top: 20px;\n  }\n  \n  .modal-table-container {\n    max-height: 400px; /* Set the maximum height for the table container */\n    overflow-y: auto; /* Add vertical scroll for the table rows */\n  }\n  \n  .modal-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .modal-table th,\n  .modal-table td {\n    padding: 8px;\n    border: 1px solid #ccc;\n  }\n  \n  .modal-table th {\n    background-color: #f2f2f2;\n    text-align: left;\n  }\n  \n  .modal-table tr:hover {\n    background-color: #f9f9f9;\n  }\n  \n  /* Search input styles */\n  .search-input {\n    margin-top: 10px;\n    padding: 8px;\n    width: 100%;\n  }\n  \n  /* Send button styles */\n  .modal-send-button {\n    margin-top: 20px;\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .modal-send-button:hover {\n    background-color: #0056b3;\n  }\n  \n  .btn-effect{\n   font-size: 10px !important;\n  }\n  \n  .scale-effect {\n    transform: scale(1.001);\n  }\n  \n  /* \"Select All\" button styles */\n  .select-all-button {\n    margin-bottom: 10px;\n    padding: 8px 12px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .select-all-button:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Add any other custom styles as needed for your specific design */\n  \n  /* SendInvoices.css */\n\n/* ... (previous styles) */\n\n/* Date Range Container */\n.date-range-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  /* Selected Date Range */\n  .selected-date-range {\n    font-weight: bold;\n  }\n  \n  /* Selected Billing Category */\n  .selected-billing-category {\n    font-weight: bold;\n  }\n  \n  /* Default Invoice Date */\n  .invoice-date {\n    font-weight: bold;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n  \n  /* Calendar Styles */\n  .calendar-container {\n    position: absolute;\n    top: calc(100% + 5px); /* Position the calendar below the Default Invoice Date element */\n    left: 0;\n    z-index: 999;\n    background-color: #fff;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n    padding: 10px;\n    display: none; /* Hide the calendar initially */\n  }\n  \n  .calendar-container.active {\n    display: block; /* Show the calendar when active */\n  }\n  \n  /* Add any other custom styles as needed for your specific design */\n  .dollor>span{\n    margin: 0px 3px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
